module.exports = __webpack_public_path__ + "img/votronic_24_100.fe111856.png";